import Modal from '@/shared/components/UI/Modal';
import Button from '@/shared/components/UI/Button';

interface ShippingPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ShippingPolicyModal: React.FC<ShippingPolicyModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="max-h-[60vh] overflow-y-auto text-left">
        <h2 className="mb-4 text-lg font-bold text-[#1D1D1D]">배송 안내</h2>
        <div className="text-sm text-[#1D1D1D]">
          <p className="mb-3">
            {' '}
            ⭐️{' '}
            <strong>
              일반 상품 및 이벤트 상품 주문 전 반드시 금액을 확인해 주시기
              바랍니다.
            </strong>{' '}
            ⭐️
          </p>

          <ul className="mb-4 list-disc space-y-2 pl-5">
            <li>
              금요일 오전 10시(한국 시간) 이후 및 주말 주문 건은 다음 주
              월요일에 처리됩니다.
            </li>
            <li>
              특정 상품이 품절된 경우 Contact Us 를 통해 문의해주세요. 배송
              처리에 영업일 기준 3-5일이 소요될 수 있습니다.
            </li>
            <li>사전 주문(PRE-ORDER) 상품은 입고 후 배송이 시작됩니다.</li>
            <li>평균 배송 기간은 발송 후 영업일 기준 3-7일입니다.</li>
            <li>한국의 모든 공휴일에는 배송 처리가 이루어지지 않습니다.</li>
          </ul>

          <p className="font-semibold">
            <strong>세금 제외, 할인 적용 후 금액 기준</strong>
          </p>
        </div>

        <div className="mt-6">
          <Button
            type="button"
            variant="primary"
            size="xs"
            onClick={onClose}
            fullWidth
          >
            Verify
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ShippingPolicyModal;
